/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

/* Thunks */

import userApi from 'api/user.api';
import { createFOAsyncThunk } from '../../../helpers/thunk.helpers';

/**
 * Fetches the users from the server
 */
export const fetchUsers = createFOAsyncThunk('users/fetchUsers', async (arg) => {
  const { pagingSortingAndFiltering, organizationId } = arg;
  const usersPage = await userApi.getUsers(organizationId, pagingSortingAndFiltering);

  return { usersPage };
});
